import React from 'react'

export default function Header() {
    return (
        <div className='container-nav'>
            <a href="https://www.ulaval.ca/" target="_blank" rel="noopener noreferrer">
                <img
                    className='logo'
                    src={require("../images/UL_banner.png")}
                    alt="UL_banner"
                />
            </a>
            <div className="vl"></div>
            <a href="https://www.cirris.ulaval.ca/" target="_blank" rel="noopener noreferrer">
                <img
                    className='logo-cirris'
                    src={require("../images/logo-cirris.png")}
                    alt="Cirris_banner"
                    height="20px"
                />
            </a>
            
        </div>
    )
}